import React, { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import { FormControl, TextField } from "@material-ui/core";
import { Col, Container } from "react-bootstrap";
import clsx from "clsx";
import { useHistory, Link } from 'react-router-dom';
import * as auth from "../../store/ducks/auth.duck";
import { login } from "../../crud/auth.crud";
import * as utils from "../../../_metronic/utils/utils";

function Login(props) {
	const [loading, setLoading] = useState(false);
	const [loadingButtonStyle, setLoadingButtonStyle] = useState({ paddingRight: "2.5rem" });
	const history = useHistory();

	const enableLoading = () => {
		setLoading(true);
		setLoadingButtonStyle({ paddingRight: "3.5rem" });
	};

	const disableLoading = () => {
		setLoading(false);
		setLoadingButtonStyle({ paddingRight: "2.5rem" });
	};

	return (
		<Container fluid className="d-flex p-0 loginContainer">
			<Col className="p-0 d-none d-lg-block" lg={6}>
				<div style={{ backgroundImage: `url('/images/login/login-left.png')`, height: '100vh', width: '100%', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }} />
			</Col>

			<Col xs={12} sm={12} md={12} lg={6} className="formSide d-flex justify-content-center">
				<Col md={9}>
					<img src="/images/logo-color.png" width="auto" height="20" alt="Logo" />

					<div className="boxLogin">
						<h1>Gestão de Pátio</h1>

						<Formik initialValues={{ email: "", password: "" }}
							validate={values => {
								const errors = {};

								if (!values.email) {
									errors.email = "O email é uma informação obrigatória.";
								} else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
									errors.email = "Você precisa informar um email válido.";
								}

								if (!values.password) {
									errors.password = "A senha é uma informação obrigatória.";
								}

								return errors;
							}} onSubmit={(values, { setStatus, setSubmitting }) => {
								enableLoading();

								login(values.email, values.password).then(res => {
									disableLoading();

									const usuario = res.data.data;

									utils.setStorage('authToken', usuario.token, null);
									utils.setStorage('user', usuario.user, null);
									utils.setStorage('permissions', usuario.permissions, null);
									props.login(usuario);
									history.push('/');
								}).catch((err) => {
									disableLoading();

									setSubmitting(false);
									let msg = "Usuário ou senha incorretos.";
									if (err.response && err.response.data && err.response.data.message) {
										msg = err.response.data.message;
									}
									setStatus(msg);
								});
							}}>

							{({ values, status, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
								<form noValidate={true} autoComplete="off" onSubmit={handleSubmit}>
									{status ? (
										<div role="alert" className="alert alert-danger">
											<div className="alert-text">{status}</div>
										</div>
									) : null}

									<FormControl fullWidth error={Boolean(touched.email && errors.email)} className="mt-5">
										<TextField type="email" variant="outlined" name="email" label="E-mail" onBlur={handleBlur} error={Boolean(touched.email && errors.email)} onChange={handleChange} value={values.email} />
									</FormControl>

									<FormControl fullWidth error={Boolean(touched.password && errors.password)} className="mt-3">
										<TextField type="password" variant="outlined" name="password" label="Senha" onBlur={handleBlur} error={Boolean(touched.password && errors.password)} onChange={handleChange} value={values.password} />
									</FormControl>

									<div className='rememberForgot d-block d-md-flex'>
										<Link to="/auth/forgot-password" className='forgot'>Esqueceu sua senha?</Link>
									</div>

									<div className="buttonContainer">
										<button id="kt_login_signin_submit" type="submit" disabled={isSubmitting} className={`btn btn-primary btn-elevate kt-login__btn-primary
                    						${clsx({ "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading })}`}
											style={loadingButtonStyle}>Entrar!</button>
									</div>
								</form>
							)}
						</Formik>
					</div>
				</Col>
			</Col>
		</Container>
	);
}

export default connect(null, auth.actions)(Login);
